@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row.is_cancelled_after_subscription_end) {
    <p-badge
      severity="secondary"
      [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.CANCELLED' | translate"
      styleClass="uppercase border-round text-xxs"
      aria-label="cancelled-timeline-status"
    />
  } @else if (
    $.row.payment_status &&
    ($.row.payment_status === paymentStatus.Successfull ||
      $.row.payment_status.toString() ===
        paymentStatus[paymentStatus.Successfull])
  ) {
    <p-badge
      severity="success"
      [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.PAID' | translate"
      styleClass="uppercase border-round text-xxs text-white"
    />
  }
  @if (
    $.row.payment_status &&
    ($.row.payment_status === paymentStatus.Failed ||
      $.row.payment_status.toString() === paymentStatus[paymentStatus.Failed])
  ) {
    <p-badge
      severity="danger"
      [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.FAILED' | translate"
      styleClass="uppercase border-round text-xxs"
    />
  }
  @if ($.row.payment_status && isInProgress($.row)) {
    <p-badge
      severity="info"
      [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.INPROGRESS' | translate"
      styleClass="uppercase border-round text-xxs"
    />
  }
}
